import React, { useRef } from 'react'

import { Child } from 'services/child/constants'

import { Masonry } from 'components'

import useMediaQuery from 'hooks/useMediaQuery'

import { StyledContainer } from './ChildPreviewStyled'
import {
  DevelopmentBreakdown,
  EnrolmentBreakdown,
  FamilyBreakdown,
  GeneralBreakdown,
  HealthAndDietBreakdown,
  LikesDislikesBreakdown,
  PermissionsBreakdown,
  RegistrationFormBreakdown,
} from './components'

interface ChildViewProps {
  child: Child
  drinkingMethods: Record<string, string>
  hasBookingPattern?: boolean
  isFormContext: boolean
  onRegistrationFormSendSubmitSuccess: () => void
  permissionToEdit: boolean
  registrationFormIncludeBookingPattern?: boolean
  showRegistrationFormSection: boolean
  toiletTrainingOptions: Record<string, string>
}

const ChildPreview: React.FC<ChildViewProps> = ({
  child = {},
  drinkingMethods,
  hasBookingPattern,
  isFormContext,
  onRegistrationFormSendSubmitSuccess,
  permissionToEdit,
  registrationFormIncludeBookingPattern,
  showRegistrationFormSection,
  toiletTrainingOptions,
}) => {
  const masonryRef = useRef<any>(null)
  const isMobile = useMediaQuery('(max-width: 915px)')

  return (
    <StyledContainer>
      <Masonry ref={masonryRef}>
        {showRegistrationFormSection && (
          <RegistrationFormBreakdown
            child={child}
            hasBookingPattern={hasBookingPattern}
            registrationFormIncludeBookingPattern={registrationFormIncludeBookingPattern}
            onRegistrationFormSendSubmitSuccess={onRegistrationFormSendSubmitSuccess}
            onToggleExpand={() => masonryRef?.current?.performLayout()}
          />
        )}
        {showRegistrationFormSection && !isMobile && (
          <React.Fragment>
            <HealthAndDietBreakdown child={child} isFormContext={isFormContext} permissionToEdit={permissionToEdit} />
            <GeneralBreakdown child={child} isFormContext={isFormContext} permissionToEdit={permissionToEdit} />
          </React.Fragment>
        )}
        {(!showRegistrationFormSection || isMobile) && (
          <React.Fragment>
            <GeneralBreakdown child={child} isFormContext={isFormContext} permissionToEdit={permissionToEdit} />
            <HealthAndDietBreakdown child={child} isFormContext={isFormContext} permissionToEdit={permissionToEdit} />
          </React.Fragment>
        )}
        <FamilyBreakdown child={child} isFormContext={isFormContext} permissionToEdit={permissionToEdit} />
        <EnrolmentBreakdown child={child} isFormContext={isFormContext} permissionToEdit={permissionToEdit} />
        <DevelopmentBreakdown
          child={child}
          drinkingMethods={drinkingMethods}
          isFormContext={isFormContext}
          permissionToEdit={permissionToEdit}
          toiletTrainingOptions={toiletTrainingOptions}
        />
        <PermissionsBreakdown child={child} isFormContext={isFormContext} permissionToEdit={permissionToEdit} />
        <LikesDislikesBreakdown child={child} isFormContext={isFormContext} permissionToEdit={permissionToEdit} />
      </Masonry>
    </StyledContainer>
  )
}

export default ChildPreview
